<template>
    <label v-if="!id" :for="getId" :class="{'sr-only' : !showLabel}">{{ label }}</label>
    <div class="bg-bhav-cool-gray-50 rounded shadow-sm inline-flex items-start" :class="[width, $attrs['class']]">
        <div class="text-bhav-blue-500 border-r border-r-bhav-cool-gray-100 p-2"><span class="fak fa-globe"></span></div>
        <input 
            type="url" 
            class="p-2 border-none w-full bg-bhav-cool-gray-50 text-bhav-blue-500" 
            :id="getId" 
            :pattern="pattern"
            :placeholder="placeholder"
            v-model="value" 
        />  
        <div aria-hidden="true" :title="value == null || value == '' ? '' : (valid ? 'URL is validated' : 'URL is invalid')" class="flex-0 p-2 rounded-r border-l border-l-bhav-cool-gray-100" :class="value == null || value == '' ? 'text-bhav-cool-gray-500 bg-bhav-cool-gray-100' : (valid ? 'text-bhav-green bg-bhav-green-100' : 'text-bhav-red bg-bhav-red-100')">
            <span class="fak fa-thumbs-up" :class="valid ? '' : 'rotate-180 scale-x-[-1]'"></span>
        </div>
        <a v-if="value && valid" :href="value" target="_blank" rel="noopener noreferrer" title="Open URL in new tab" class="flex-0 p-2 border-l border-l-bhav-cool-gray-100 text-bhav-blue-500 bg-bhav-cool-gray-50 hover:bg-bhav-cool-gray-100 cursor-pointer">
            <span class="fas fa-arrow-up-right-from-square"></span>
        </a>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pattern: /^(https?):\/\/([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}(:\d+)?(\/[^\s]*)?$/i
        }
    },
    emits: [
        'update:modelValue'
    ],
    props: {
        id: {
            type: [Boolean, String],
            default: false
        },
        placeholder: {
            type: String,
            default: "https://website.com/my-url"
        },
        modelValue: {
            required: true
        },
        width: {
            type: String,
            default: "w-full sm:w-1/2"
        },
        showLabel: {
            type: Boolean,
            default: true
        },
        label: {
            type: String,
        }
    },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        },
        valid() {
            if(!this.value) return true;
            let matches = this.pattern.exec(this.value);
            return matches && matches[1];
        },
        getId() {
            return this.id || `field-${this.$.uid}`;
        }
    }  
}
</script>

<style>
</style>